import { resolveMessage, t } from '../i18n/translate';

/** Traditional Seventh Step Prayer from Alcoholics Anonymous, page 76. */
export function getTraditionalSeventhStepPrayer(): string {
  return t('step.7.prayer.traditional_text');
}

export function getTraditionalSeventhStepPrayerSource(): string {
  return t('step.7.prayer.traditional_source');
}

/** Share/PDF HTML is not localized yet, so it stays pinned to English. */
export const TRADITIONAL_SEVENTH_STEP_PRAYER = resolveMessage('step.7.prayer.traditional_text', {
  locale: 'en',
});

export const TRADITIONAL_SEVENTH_STEP_PRAYER_SOURCE = resolveMessage(
  'step.7.prayer.traditional_source',
  { locale: 'en' }
);
